import type { AdminKpisPdfSectionProps } from "../../models/admin-kpis.models";
import { getAdminKpisSegmentSwatchColorClassName } from "../../utils/admin-kpis.utils";
import "./AdminKpisPie.css";
import AdminKpisPdfMetric from "./AdminKpisPdfMetric";
import AdminKpisPieChart from "./AdminKpisPieChart";
import { memo } from "react";

const AdminKpisPdfSection = ({ title, section }: AdminKpisPdfSectionProps) => {
  return (
    <section className="admin-kpis-print-section">
      <div className="admin-kpis-print-section-header">
        <h2>{title}</h2>
        <span>{section.total} vessels</span>
      </div>

      <div className="admin-kpis-print-section-body">
        <AdminKpisPieChart segments={section.segments} total={section.total} showSegmentPercentLabels />

        <div className="admin-kpis-print-legend">
          {section.segments.map((segment) => (
            <div className="admin-kpis-print-legend-row" key={segment.code}>
              <span
                className={`admin-kpis-print-legend-swatch ${getAdminKpisSegmentSwatchColorClassName(segment.code)}`}
              />
              <span className="admin-kpis-print-legend-label">{segment.label}</span>
              <span className="admin-kpis-print-legend-value">{segment.value}</span>
            </div>
          ))}
          <div className="admin-kpis-print-target">TARGET: max 10%</div>
        </div>
      </div>

      <div className="admin-kpis-print-metrics">
        {section.kpis.map((metric) => (
          <AdminKpisPdfMetric key={metric.label} metric={metric} />
        ))}
      </div>
    </section>
  );
};

export default memo(AdminKpisPdfSection);
